import React from 'react';
import AnnouncementBanner from '../components/sections/AnnouncementBanner';
import Hero from '../components/sections/Hero';
import ValueStrip from '../components/sections/ValueStrip';
import ServicesSection from '../components/sections/ServicesSection';
import WhatToExpect from '../components/sections/WhatToExpect';
import TeamSection from '../components/sections/TeamSection';
import PaymentSection from '../components/sections/PaymentSection';
import LocationSection from '../components/sections/LocationSection';
import useReveal from '../hooks/useReveal';
import useSeo from '../hooks/useSeo';

export default function HomePage({ onBookClick }) {
  useReveal();
  useSeo({
    title: 'Beechwood Dental Studio | Family Dentist in Waterloo, ON',
    description: 'Modern, family-focused dental care in Waterloo, ON. Preventative, restorative, cosmetic and surgical dentistry with a gentle, patient-first approach. Book online today.',
    path: '/'
  });
  return (
    <div>
      <AnnouncementBanner />
      <Hero onBookClick={onBookClick} />
      <ValueStrip />
      <ServicesSection />
      <WhatToExpect />
      <TeamSection />
      <PaymentSection onBookClick={onBookClick} />
      <LocationSection onBookClick={onBookClick} />
    </div>
  );
}
